var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetamask = function SvgMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "metamask_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#metamask_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.781,
    d: "m18.954 13.844-1.208 3.927-2.37-.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.781,
    d: "m15.376 17.147 2.286-3.012 1.292-.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    d: "m17.178 10.887 1.777 2.96-1.292.29zm0 0 1.143-.762.634 3.722z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m17.178 10.887 1.777 2.96m-1.777-2.96.485 3.25 1.292-.29m-1.777-2.96 1.143-.762.634 3.722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    d: "m15.722 8.648 3.287-1.295-.163.709zm3.02.267-3.02-.267 3.124-.586z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m15.722 8.648 3.287-1.295-.163.709m-3.124.586 3.124-.586m-3.124.586 3.02.267.104-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    d: "m18.741 8.915-.42 1.208-2.599-1.475zm.659-1.262-.554.41.163-.71zm-.659 1.262.105-.853.44.352z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m18.741 8.915-.42 1.208-2.599-1.475zm0 0 .105-.853m-.105.853.545-.5-.44-.353m0 0 .554-.409-.391-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.781,
    d: "m12.826 16.193.822.253 1.727.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    d: "m18.32 10.125.421-1.209.361.267zm0 0-3.41-1.08.812-.395zm-1.786-5.184-.812 3.708-.812.395zm2.475 2.413L15.722 8.65l.812-3.708z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m18.32 10.125.421-1.209.361.267zm0 0-3.41-1.08.812-.395zm-1.786-5.184-.812 3.708m.812-3.708L14.91 9.044l.812-.395m.812-3.708 2.475 2.413-3.287 1.295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m16.534 4.94 3.43-.38-.955 2.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m18.32 10.125-1.143.761-2.267-1.841z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m19.815 1.89.149 2.671-3.43.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.781,
    d: "m19.815 1.89-6.856 4.794-.089-3.25 6.945-1.543Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m7.772 3.041 5.098.391.09 3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m14.91 9.044-1.95-2.36 3.574-1.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    d: "m14.91 9.044 2.267 1.842-3.182.338zm-.915 2.18L12.96 6.683l1.95 2.361z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E4761B",
    strokeWidth: 0.781,
    d: "m14.91 9.044 2.267 1.842-3.182.338zm0 0-1.95-2.361 1.035 4.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "M16.534 4.942 12.96 6.683l6.855-4.792-3.281 3.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.781,
    d: "m7.816 17.073 1.619 1.623-2.202-1.928.583.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.781,
    d: "m15.376 17.149.766-2.804 1.52-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.781,
    d: "M1.254 9.26 4.056 6.43l-2.44 2.494z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m17.661 14.136-1.519.21 1.035-3.46.485 3.25ZM12.96 6.683l-2.727-.086-2.46-3.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.781,
    d: "m17.177 10.886-1.035 3.46-.084-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.781,
    d: "m13.995 11.224 3.182-.338-1.118 1.77-2.065-1.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m10.232 6.597 2.728.085 1.034 4.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.781,
    d: "M10.233 6.598 2.873.05l4.9 2.994zM7.768 18.07l-6.395 1.904-1.277-4.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "M2.204 10.433 4.619 8.61l2.025.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m6.644 9.063-2.025-.452 1.084-4.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "M1.616 8.924 4.62 8.61l-2.415 1.823z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.781,
    d: "m16.058 12.655-1.247-.604-.816-.829 2.063 1.433Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m1.616 8.925-.213-1.08 3.217.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.781,
    d: "m14.554 13.413.258-1.361 1.247.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m16.143 14.344-1.589-.932 1.505-.757z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    d: "m4.62 8.611-3.218-.766-.262-.91zm1.084-4.303L4.62 8.611 1.14 6.936zm0 0 4.529 2.29-3.589 2.465z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m4.62 8.611-3.218-.766-.262-.91m3.48 1.676L1.14 6.936M4.62 8.61l1.084-4.303M1.14 6.936l4.564-2.627m0 0 4.529 2.29-3.589 2.464-.94-4.754"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    d: "m6.644 9.062 3.589-2.465 1.598 4.697zm5.188 2.232-4.96-.1-.228-2.132z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E4761B",
    strokeWidth: 0.781,
    d: "m6.644 9.062 3.589-2.465 1.598 4.697M6.645 9.062l5.188 2.232M6.644 9.062l.228 2.133 4.96.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m2.204 10.433 4.44-1.37.228 2.131zm11.79.79-2.163.072-1.599-4.698z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.781,
    d: "m14.811 12.05-.258 1.362-.558-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m2.873.05 7.36 6.548-4.53-2.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.781,
    d: "m.096 15.283 6.207-.248 1.465 3.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.781,
    d: "m7.768 18.068-1.465-3.031 3.05-.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    d: "m14.554 13.413 1.59.933.875 1.985zm-7.682-2.218L.096 15.284l2.109-4.85zm-.569 3.84-6.207.249 6.776-4.09zm7.692-3.812.406 1.419-1.96.11zm-1.554 1.528-.609-1.456 2.163-.072z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "M6.872 11.195.096 15.284m6.776-4.09-4.667-.76-2.109 4.85m6.776-4.09-.569 3.842-6.207.248m13.9-4.06.405 1.418-1.96.11m1.554-1.529-1.554 1.528m1.554-1.528-2.163.072.61 1.456m1.553-1.528-1.554 1.528m2.113.662 1.59.933.875 1.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.781,
    d: "m9.437 18.698-1.669-.629 5.801.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m2.204 10.434-.95-1.17.361-.339z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.781,
    d: "m14.228 18.312-.658.695-5.802-.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.781,
    d: "m14.54 16.607-6.772 1.461 1.584-3.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.781,
    d: "m7.768 18.065 6.771-1.46-.312 1.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m1.14 6.934-.223-3.66 4.787 1.033zm.475 1.99L.957 8.28l.445-.438z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    d: "m10.723 12.238 1.11-.943-.16 2.304zm1.108-.943-1.108.943-1.614.804 2.723-1.747"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CD6116",
    strokeWidth: 0.781,
    d: "m11.832 11.295-1.109.943.95 1.361zm0 0L9.11 13.042l1.614-.804 1.108-.943z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m17.02 16.331-.302-.213-2.164-2.704 2.466 2.918Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.781,
    d: "m9.108 13.041-2.237-1.847 4.96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.781,
    d: "m11.672 13.599.159-2.304.608 1.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "m.74 7.298.4-.362.263.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.781,
    d: "m11.673 13.599-2.564-.557 1.614-.804.95 1.361Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.781,
    d: "M5.704 4.309.917 3.276 2.872.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.781,
    d: "m13.569 19.005.272.715-4.405-1.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m9.352 14.894-.243-1.85 2.564.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.781,
    d: "m6.87 11.194 2.238 1.847.243 1.851-2.48-3.698Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m12.44 12.752 1.96-.11 2.317 3.475zm-5.568-1.556 2.48 3.698-3.049.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.781,
    d: "m12.44 12.751 2.435 3.565-3.203-2.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m11.672 13.597 3.203 2.717-.337.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.781,
    d: "m14.54 16.607-5.188-1.714 2.321-1.294zm2.177-.49-1.841.2-2.435-3.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    d: "m17.202 17.793-.792 1.527-2.57.4zM13.84 19.72l-.271-.714.657-.695z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C0AD9E",
    strokeWidth: 0.781,
    d: "m13.84 19.72 2.57-.4.791-1.527zm0 0 .386-1.409-.657.695.271.714Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    d: "m14.228 18.311.485-.185-.871 1.594zm-.386 1.409.871-1.594 2.49-.334z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C0AD9E",
    strokeWidth: 0.781,
    d: "m14.713 18.126-.485.185-.386 1.409m.871-1.594-.871 1.594m.871-1.594 2.49-.334-3.361 1.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.781,
    d: "m16.716 16.116.609.357-1.851.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.781,
    d: "m15.475 16.687-.6-.371 1.841-.2zm-.213.281 2.252-.262-.312 1.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "m17.202 17.793-2.49.333.55-1.157zm-2.49.333-.485.185.312-1.703zm-.173-1.518.337-.29.599.37zm2.786-.134.189.233-2.252.262z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#161616",
    strokeWidth: 0.781,
    d: "m14.712 18.126 2.49-.334-1.94-.823m-.55 1.157.55-1.157m-.55 1.157-.485.185.312-1.703m.173 1.518-.173-1.518m.723.36 2.252-.26-.189-.234zm-.723-.36.337-.29.599.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "m15.261 16.97.213-.28 1.851-.215zm-.722-.362.722.362-.55 1.156zm.935.08-.213.28-.722-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#161616",
    strokeWidth: 0.781,
    d: "m15.261 16.97.213-.28 1.851-.215zm0 0-.722-.362.173 1.518zm.213-.282-.213.28-.722-.36z"
  }))));
};
export default SvgMetamask;